export const orderFeesFormFields = {
  baseToBaseFeeInDollars: "baseToBaseFeeInDollars",
  feeAppliesPerItem: "feeAppliesPerItem",
  feePerDeliveryInDollars: "feePerDeliveryInDollars",
  feePerPickupInDollars: "feePerPickupInDollars",
  freeLocalDeliveriesPerSeason: "freeLocalDeliveriesPerSeason",
  freeLocalPickupsPerSeason: "freeLocalPickupsPerSeason",
};
